/** @jsx jsx */

import { css, jsx } from "@emotion/react";

import arrowDownSmall from "../../images/arrow-down-small.svg";

const ReviewsLink = ({ to, color }) => (
    <a
        href={to}
        target="_blank"
        rel="noreferrer"
        css={css`
            font-size: 1.6rem;
            line-height: 2.5rem;
            cursor: pointer;
            padding: 1rem 3rem;
            font-weight: bold;
            border: 1px solid;
            border-radius: 1rem;
            color: ${color};
            display: inline-block;
            margin: 3rem auto;
        `}
    >
        Read Reviews
    </a>
);

export default ReviewsLink;
